
<template lang="pug">
q-page.fit
  .absolute-full.column

    //- ツールバー
    .col-auto
      .flex.justify-between.q-ma-xs
        .flex.items-center

          //- 説明文
          .weekly-store_notice ※ここでの設定はすでに作成されているシフトには適用されません。次に追加される4週期間からの適用となります。

    //- グリッド
    .col.grid
      .grid__table(
        v-show="showGrid"
        ref="table"
        :style="gridTableStyle"
        @mousedown.left.stop="onMouseDownLeft"
      )
        .grid__thead

          //- コーナー
          .grid__corner-area(@contextmenu.prevent)
            .grid__tr
              .grid__corner(:style="gridCornerStyle")

          //- 列ヘッダ
          .grid__column-header-area(@contextmenu.prevent)
            .grid__column-header-cursor(:style="gridColumnHeaderCursorStyle")
            grid-columns(
              :grid="grid"
              :cols="cols"
            )

        .grid__row-area

          //- 行ヘッダ
          .grid__row-header-area(@contextmenu.prevent)
            .grid__row-header-cursor(:style="gridRowHeaderCursorStyle")
            .grid__tr(v-for="row of rows")
              .grid__row-header.grid__left(:style="gridRowHeaderStyle") {{row.text}}

          //- セル
          .grid__cell-area(
            @dblclick="onCellDoubleClick"
            @mousedown.left.stop="onCellMouseDownLeft"
          )
            .grid__cell-cursor(:style="gridCellCursorStyle")
            grid-cells(
              :grid="grid"
              :rows="rows"
            )

            ContextMenu2(@beforeShow="onCellContext")

  //- RE値の入力
  PopupRE(
    ref="popupRE"
    @confirm="confirmRE"
  )
    q-btn.q-mx-sm(
      color="secondary"
      flat
      @click="deleteRE"
    ) 基本値

</template>

<script>
import {weeks} from 'helpers/date'
import {mapAuto} from 'helpers/vuex-bind'

import PopupRE from 'components/PopupRE'
import AxiosMixin from 'mixins/axios'
import GridMixin from 'mixins/GridMixin'

export default {
  components: {PopupRE},
  mixins: [AxiosMixin, GridMixin],

  props: {
    storeCode: String,
    floorCode: String,
  },

  data() {
    return {
      grid: {
        cellW:    70,
        cellH:    25,
        headerW:  80,
        headerH:  25,
        paddingW: 20,
        paddingH: 20,
      },

      weekly_store: [],

      clipboard: {},

      re_name: [
        'レーンレジ',
        'セミセルフレジ',
        'カウンターレジ',
        '概算用',
      ],
    }
  },

  computed: {
    ...mapAuto(['stores']),

    viewKey() {
      return Object.values(this.$props).some(v => v == null)
        ? null
        : this.storeCode + '/' + this.floorCode
    },

    store() {
      return this.stores.find(store =>
        store.store_code == this.storeCode &&
        store.floor_code == this.floorCode) || {}
    },

    cols() {
      return weeks.slice(0, 7).map((v, week) => ({
        text: v.long,
        style: {color: v.color},
        type: 'RE',
        week,
      }))
    },

    rows() {
      const data = this.weekly_store
      const rows = []
      for(let ire = 0; ire < 4; ++ire) {
        const cells = []
        for (let iweek = 0; iweek < 7; ++iweek) {
          let text = data[`re${ire + 1}_${iweek}`]
          if (text == null) {
            cells.push({ text: data[`re${ire + 1}`], style: {color: '#ccc'}})
          } else {
            cells.push({ text })
          }
        }
        rows.push({
          id: ire,
          text: this.re_name[ire],
          cells,
        })
      }
      return rows
    },
  },

  watch: {
    viewKey() {
      this.refresh()
    },
  },

  mounted() {
    this.refresh()
  },

  methods: {

    async refresh() {
      try {
        if(this.viewKey != null) {

          // 表示を一旦クリアする
          this.people = []
          this.grid.cursor = {x: 0, y: 0}

          //
          const { data } = await this.axios.get('/api/weekly_stores/' + this.viewKey)
          this.weekly_store = data
        }
      }
      catch(e) {this.$handler(e)}
    },

    key0(y)      { return `re${y + 1}` },
    key1(x, y)   { return `re${y + 1}_${x}` },
    value0(y)    { return this.weekly_store[this.key0(y)] },
    value1(x, y) { return this.weekly_store[this.key1(x, y)] },

    async updateWeeklyStore(id, x, y, re) {
      const orig = this.weekly_store
      const data = { ...this.weekly_store, id, [this.key1(x, y)]: re }
      const diff = Object.entries(data).reduce((a, [k, v]) => ({...a, ...v !== orig[k] ? {[k]: v} : {}}), {})
      if(Object.keys(diff).length !== 0) {
        await this.axios.put('/api/weekly_stores/' + id, diff)
        this.weekly_store = data

        // vue-storeも書き換える
        const istore = this.stores.findIndex(x => id === x.id)
        if (istore !== -1) this.stores[istore] = data
      }
    },

    //-------------------------------------------------------------------------

    // 左クリックでセルの選択、左ドラッグでスクロール

    onMouseDownLeft(e) {
      this.beginDragScroll(e)
    },

    onCellMouseDownLeft(e) {
      this.selectCell(e)
      this.beginDragScroll(e)
    },

    // キー押下

    onKeyDown(e) {
      if(this.processKeyDown(e)) {
        return
      }

      // 削除 (Backspace/Deleteキー押下)
      if(e.key === 'Backspace' || e.key === 'Delete') {
        if(!this.isEditing) {
          this.callTyped('delete')
          e.preventDefault()
        }
        return
      }
    },

    // 編集開始 (cell領域をダブルクリック, Enterキー押下)

    onCellDoubleClick(e) {
      this.selectCell(e)
      this.callTyped('beginEdit')
    },

    onPressEnterBeginEdit() {
      this.callTyped('beginEdit')
    },

    // コピー/ペースト

    onClipboardCopy() {
      this.callTyped('clipboardCopy')
    },

    onClipboardPaste() {
      this.callTyped('clipboardPaste')
    },

    // cell領域のコンテキストメニュー
    onCellContext(e, options) {
      this.selectCell(e)
      options([{
        label: '編集', onClick: () => {
          this.callTyped('beginEdit')
        },
      }])
    },

    //-------------------------------------------------------------------------

    // RE値の編集開始

    beginEditRE() {
      const {x, y} = this.grid.cursor
      this.$refs.popupRE.show(
        this.value0(y),
        this.value1(x, y),
        {
          title: `${this.store.name} (${this.store.floor_name}) - ${this.re_name[y]} - ${weeks[x].long}`,
          id: this.weekly_store.id,
          x, y,
        },
      )
    },

    // RE値の削除

    deleteRE() {
      const {x, y} = this.grid.cursor
      this.confirmRE(null, { id: this.weekly_store.id, x, y })
    },

    // RE値の編集終了

    async confirmRE(re, { id, x, y }) {
      try {
        await this.updateWeeklyStore(id, x, y, re)
        this.$refs.popupRE.hide()
      } catch (e) { this.$handler(e) }
    },

    // RE値のコピー/ペースト

    clipboardCopyRE() {
      const {x, y} = this.grid.cursor
      let re = this.value1(x, y)
      if (re == null) re = this.value0(y)
      this.clipboard = { re }
    },

    async clipboardPasteRE() {
      try {
        if ('re' in this.clipboard) {
          const {x, y} = this.grid.cursor
          await this.updateWeeklyStore(this.weekly_store.id, x, y, this.clipboard.re)
        }
      } catch (e) { this.$handler(e) }
    },

    //-------------------------------------------------------------------------

    callTyped(method, ...args) {
      const {x, y} = this.grid.cursor
      method += this.cols[x].type
      if(method in this) {
        this[method](...args)
      }
    },
  },
}
</script>

<style lang="sass">
.weekly-store_notice
  padding: 0.4em
</style>
